if (!customElements.get('product-grid')) {
    customElements.define(
        'product-grid',
        class VariantAvailability extends HTMLElement {
            constructor() {
                super();
                this.getVisitorInfo();
            }

            getVisitorInfo() {
                fetch('https://pro.ip-api.com/json/?key=z3TRAutYsWWqWl8&fields=countryCode')
                    .then((response) => response.text())
                    .then((responseText) => {
                            const jsonResponse = JSON.parse(responseText);
                            let buttons = document.getElementsByClassName('quick-add-buy-now__submit');
                            for (var i = 0; i < buttons.length; i++) {
                                let button = buttons[i];
                                button.dataset.country = jsonResponse.countryCode;// === 'GB' ? 'UK' : jsonResponse.countryCode;
                                this.toggleAddButton(
                                    button,
                                    button.hasAttribute('disabled'),
                                    button.dataset.locations
                                );
                            }
                        }
                    );
            }

            toggleAddButton(button, disable = true, locations, modifyClass = true) {
                // const productForm = document.getElementById(`product-form-${this.dataset.section}`);
                // if (!productForm) return;
                let addButton = button;
                const addButtonText = addButton.querySelector('[name="add"] > span');
                if (!addButton) return;

                // const ukir = ["UK", "IR"];
                // let locations = addButton.dataset.locations;
                // let inter = intersect(ukir, locations.split(","));
                if (locations.includes('IR') && euList.includes(addButton.dataset.country)
                    || locations.includes('US') && usList.includes(addButton.dataset.country)
                    || locations.includes('AU') && auList.includes(addButton.dataset.country)
                    || locations.includes('UK') && !euList.includes(addButton.dataset.country) && !usList.includes(addButton.dataset.country) && !auList.includes(addButton.dataset.country)
                ) {
                    addButton.removeAttribute('disabled');
                    addButtonText.textContent = window.variantStrings.addToCart;
                } else {
                    addButton.setAttribute('disabled', 'disabled');
                    addButtonText.textContent = window.variantStrings.soldOut;
                }

                if (!modifyClass) return;
            }
        }
    );
}
